import React from "react";
import config from "../../../config";
import { Button } from "../Button";

export const StripeButton = ({ path }) => {
    return (
        <Button
            square
            size="small"
            icon="stripe"
            title="Open in Stripe"
            link={`${config.STRIPE_DASHBOARD_URL}${path}`}
        />
    );
};
